import StraightenIcon from '@portalterreno/react-ui-icons/StraightenIcon';

import ContactFormTypography from '../ContactForm/ContactFormTypography';
import CampaignDiscountChip from './CampaignDiscountChip';
import StyledCampaignContactFormDiv, {
  StyledCampaignContactFormDivProps
} from './StyledCampaignContactFormDiv';

export type CampaignContactFormProps = StyledCampaignContactFormDivProps & {
  surface: number;
  surfaceUnit: string;
  campaignChipText: string;
};

const CampaignContactForm: React.FC<CampaignContactFormProps> = ({
  surface,
  surfaceUnit,
  campaignChipText,
  ...rest
}) => {
  return (
    <StyledCampaignContactFormDiv {...rest}>
      <div>
        <ContactFormTypography
          variant='text'
          align='left'
          color='blackCoral'
          weight='light'
          style={{ display: 'inline-flex', alignItems: 'center' }}
        >
          <StraightenIcon style={{ marginRight: '5px' }} /> Desde{' '}
          {Number(surface).toLocaleString(process.env.NEXT_PUBLIC_LANGUAGE)}{' '}
          {surfaceUnit}
        </ContactFormTypography>
      </div>
      <CampaignDiscountChip campaignChipText={campaignChipText} />
    </StyledCampaignContactFormDiv>
  );
};

export default CampaignContactForm;
